<template>
  <SoPageWithHeader title="DCA">
    <SoButton
      type="text"
      title="Back to warrants"
      prepend-icon="arrow-left"
      class="mb-4 px-0"
      data-testid="warrants-dca-back-btn"
      :to="{
        name: RouteNames.AdminServiceWarrants,
        params: { serviceName: $route.params.serviceName },
      }"
    />

    <SoTabs v-model="currentTab" divider data-testid="warrants-dca-tabs">
      <SoTab title="Queue">
        <div class="pt-4">
          <WarrantsDcaQueueTab />
        </div>
      </SoTab>
      <SoTab title="Tickets">
        <div class="pt-4">
          <WarrantsDcaTicketsTab />
        </div>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import WarrantsDcaQueueTab from "./components/WarrantsDcaQueueTab.vue"
  import WarrantsDcaTicketsTab from "./components/WarrantsDcaTicketsTab.vue"
  import { RouteNames } from "@/types/router"

  // Tab indices match the order the SoTab children are declared.
  export enum WarrantsDcaTab {
    Queue = 0,
    Tickets = 1,
  }

  // URL slug for each tab (index aligns with WarrantsDcaTab) so the active tab
  // is reflected in the `?tab=` query — deep-linkable and restored on back nav.
  const TAB_SLUGS = ["queue", "tickets"]

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoButton,
      SoTabs,
      SoTab,
      WarrantsDcaQueueTab,
      WarrantsDcaTicketsTab,
    },
    data() {
      return {
        RouteNames,
      }
    },
    computed: {
      // The active tab is driven by the `?tab=` query param.
      currentTab: {
        get(): WarrantsDcaTab {
          const index = TAB_SLUGS.indexOf(this.$route.query.tab as string)
          return index === -1 ? WarrantsDcaTab.Queue : index
        },
        set(tab: WarrantsDcaTab) {
          // replace (not push) so switching tabs doesn't spam browser history.
          this.$router.replace({
            query: { ...this.$route.query, tab: TAB_SLUGS[tab] },
          })
        },
      },
    },
  })
</script>
